import { Container, Col, Row } from "react-bootstrap";
import React, { useEffect, useState, useMemo, useContext } from "react";
import EquityImg from "../../../Images/product-equity.png";
import "./ExploreMutualFund.css";
// import Autocomplete from 'react-autocomplete'
import URLstateContext from "../../../provider/CommonContext";
// import "../ExploreEquities/Custom.css"
// import "../ExploreEquities/Custom.css"
import { useNavigate } from "react-router-dom";
// import Autocomplete from "../../AllEquities/Autocomplete/Autocomplete";


function ExploreMutualFund(props) {

    const { BaseURL } = useContext(URLstateContext);
    const [companysearch, setcompanysearch] = useState([]);
    const [companyName, setcompanyName] = useState([])
    const [setTextval, setText] = useState([])
    const [suggestions, setSuggestions] = useState([])
    const [showResults, setShowResults] = useState(false);
    let navigate = useNavigate();
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    function Loadcompany(setTextval) {
        setShowResults(true);
        const getSectorListUrl = BaseURL + "companysearchMutualFund/" + setTextval;
        // console.log("getSectorListUrl+" + getSectorListUrl)
        fetch(`${getSectorListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                //  console.log(JSON.stringify(myrepo))
                getval = myrepo; 
                for (var i = 0; i < getval.length; i++) {
                    // alert("hh")
                    DataFilter.push({
                        CompName: getval[i]['SCH_NAME'],
                        MFCODE: getval[i]['MF_SCHCODE'],
                        // Exchange: getval[i]['Exchange']

                    });
                }
                // console.log(CompName)
                matchcomp = DataFilter;
                setSuggestions(matchcomp);
            })
            .catch((error) => {
                //  console.log(error);
            });
    }
    const onSuggestHandler = event => { setSuggestions([]) }
    const getselectedcompany = (event, param) => { }
    const onChangeHandler = event => {
        let matches = [];
        setText(event.target.value);
        var nameComp = event.target.value;
        if (nameComp.length > 1) {
            Loadcompany(setTextval);
        }
        else {
            setShowResults(false);
            DataFilter = [];
            setSuggestions(DataFilter);
        }
    };


    // const companyClick = ( paramcode, paramname, paramexchange) =>{
    //     navigate("/Mutual-Fund/"  + paramcode + "/", {
    //     });
    // }
    const companyClick = (paramcode, paramname) => {
        setShowResults(false);
        document.getElementById('compTextMut').value = paramname;
        window.location.href = "/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', '');
    }
    return (
        <>
            <div className="bgcolormutual">

                <section className="explore-mutual">
                    <Container>
                        <Row>
                            <Col md={{ span: 6, offset: 3 }}>
                                <h3>
                                    <span>Explore Mutual Fund</span>
                                </h3>
                                <h5>Search stocks, indices</h5>
                                <input id="compTextMut" type="text" placeholder="Type to search"
                                    onChange={onChangeHandler}
                                />
                                {/* <input type="text" placeholder="Type to search"
                                   
                                /> */}
                                {showResults ?
                                    <div className="suggestion newsug">
                                        {suggestions && suggestions.map((suggestion, i) =>
                                            // <div className="suggestion col-md-12 justify-content-md-center padd-content"  data-id={suggestion.MFCODE}>{suggestion.CompName}</div>
                                            <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.MFCODE, suggestion.CompName)}>{suggestion.CompName}</div>
                                        )}
                                    </div> : ""}
                                <div className="ExploremutualBtn">
                                    <div className="ExploremutualBtnDiv">
                                        <a href="/AllMutualFund">
                                            <span>Explore all Mutual Fund</span>
                                        </a>
                                        {/* <a>
                                        <span>Explore all Mutual Fund</span>
                                    </a> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </>
    );
}
export default ExploreMutualFund;
